import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Placeholder from 'flarum/common/components/Placeholder';

export default class UserCoursesPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    
    this.loading = true;
    this.moreResults = false;
    this.courses = [];
    this.loadLimit = 20;
    this.currentPage = 1;
    
    // 加载用户
    this.loadUser(m.route.param('username'));
  }

  show(user) {
    super.show(user);
    
    // 用户加载完成后，加载课程列表
    if (this.user) {
      this.refresh();
    }
  }

  content() {
    if (this.courses.length === 0 && !this.loading) {
      return (
        <div className="UserCoursesPage">
          <Placeholder text={app.translator.trans('tf-cns-courses.forum.courses.empty')} />
        </div>
      );
    }

    let footer;

    if (this.loading) {
      footer = <LoadingIndicator />;
    } else if (this.moreResults) {
      footer = (
        <div className="UserCoursesPage-loadMore">
          <Button className="Button" onclick={this.loadMore.bind(this)}>
            {app.translator.trans('core.forum.user.posts_load_more_button')}
          </Button>
        </div>
      );
    }

    return (
      <div className="UserCoursesPage">
        <ul className="UserCoursesPage-list">
          {this.courses.map((course) => this.renderCourseItem(course))}
        </ul>
        <div className="UserCoursesPage-loadMore">{footer}</div>
      </div>
    );
  }

  renderCourseItem(course) {
    const coverImageUrl = course.cover_image 
      ? (course.cover_image.startsWith('http') 
          ? course.cover_image 
          : app.forum.attribute('baseUrl') + '/' + course.cover_image)
      : null;

    return (
      <li key={course.id} className="UserCoursesPage-item">
        <div 
          className="UserCoursesPage-item-card"
          onclick={() => this.viewCourse(course)}
        >
          {coverImageUrl ? (
            <div 
              className="UserCoursesPage-item-cover"
              style={{
                backgroundImage: `url(${coverImageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            />
          ) : (
            <div className="UserCoursesPage-item-cover UserCoursesPage-item-cover-placeholder">
              <i className="fa-light fa-book"></i>
            </div>
          )}
          <div className="UserCoursesPage-item-info">
            <div className="UserCoursesPage-item-header">
              <h3 className="UserCoursesPage-item-name">{course.name}</h3>
              {course.user_status && this.renderUserStatusTag(course.user_status)}
            </div>
            {course.description && (
              <div className="UserCoursesPage-item-description">
                {course.description}
              </div>
            )}
            <div className="UserCoursesPage-item-meta">
              <span className="UserCoursesPage-item-members">
                <i className="fa-light fa-users"></i>
                {course.member_count || 0} {app.translator.trans('tf-cns-courses.forum.courses.members')}
              </span>
            </div>
          </div>
        </div>
      </li>
    );
  }

  renderUserStatusTag(userStatus) {
    if (!userStatus) {
      return null;
    }

    // 判断是否为组员：role 为 "member" 且 status 为 "approved"
    const isMember = userStatus.role === 'member' && userStatus.status === 'approved';
    
    // 判断是否为版主/管理员：role 为 "admin" 或 "moderator"
    const isModerator = userStatus.role === 'admin';

    if (isMember) {
      return (
        <span className="UserCoursesPage-item-tag UserCoursesPage-item-tag--joined">
          {app.translator.trans('tf-cns-courses.forum.courses.joined')}
        </span>
      );
    }

    if (isModerator) {
      return (
        <span className="UserCoursesPage-item-tag UserCoursesPage-item-tag--moderator">
          {app.translator.trans('tf-cns-courses.forum.courses.moderator')}
        </span>
      );
    }

    return null;
  }

  viewCourse(course) {
    if (course && course.id) {
      m.route.set(app.route('groupDetail', { id: course.id }));
    }
  }

  refresh() {
    this.loading = true;
    this.courses = [];
    this.currentPage = 1;

    m.redraw();

    this.loadResults().then(this.parseResults.bind(this));
  }

  loadResults(offset = 0) {
    if (!this.user) return Promise.resolve([]);

    return app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/cns-courses/user-purchased-courses',
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
      params: {
        'filter[userId]': this.user.id(),
        page: Math.floor(offset / this.loadLimit) + 1,
        limit: this.loadLimit
      }
    });
  }

  loadMore() {
    this.loading = true;
    this.currentPage++;
    this.loadResults((this.currentPage - 1) * this.loadLimit).then(this.parseResults.bind(this));
  }

  parseResults(results) {
    this.loading = false;

    if (results && results.data) {
      // 避免重复添加
      const existingIds = this.courses.map(c => c.id);
      const newCourses = results.data.filter(c => !existingIds.includes(c.id));
      
      this.courses.push(...newCourses);
      this.moreResults = results.meta?.has_next_page || false;
    }

    m.redraw();

    return results;
  }
}

